import React, { useEffect, useState } from "react";
import styles from './OccupationInputs.module.scss'
import { Lang } from "../../../types/common-types";
import AccountForm from "../../../types/account-form.types";
import SelectInput from "../../../shared/Inputs/SelectInput/SelectInput";
import { validateString, smartValidateString, validatePhone } from '../../../validate/validators'
import DatePicker from '../../../shared/Inputs/DatePicker/DatePicker'
import { actions, Dispatch, State } from "../../../state-actions-reducers";
import TextInput from "../../../shared/Inputs/TextInput/TextInput";
import PhoneInput from "../../../shared/Inputs/PhoneInput/PhoneInput";

interface OccupationInputsProps {
    lang: Lang
    state: State
    dispatch: Dispatch
    accountForm: any
    invalidFields: string[]
}
export default function OccupationInputs({ lang, state, dispatch, accountForm, invalidFields }: OccupationInputsProps) {
    const [focus, setFocus] = useState('')

    useEffect(() => {
        if (!state.occupationType) state.occupationType = '10'
    }, [lang])

    useEffect(() => {
        // учусь
        if (state.occupationType === "10") {
            state.occupationInstitution = ""
            state.occupationPosition = ""
            state.workPhoneNumbers = []
        }
        // работаю
        if (state.occupationType === "20") {
            state.collegeName = ""
            state.collegeProfession = ""
            state.collegeStartedAt = ""
            state.collegeEndedAt = ""
        }
        // не работаю и не учусь
        if (state.occupationType === "40") {
            state.collegeName = ""
            state.collegeProfession = ""
            state.collegeStartedAt = ""
            state.collegeEndedAt = ""
            state.occupationInstitution = ""
            state.occupationPosition = ""
            state.workPhoneNumbers = []
        }

    }, [state.occupationType])
    const ocupationTypeOptions = [
        { value: "10", label: accountForm.studying },
        { value: "20", label: accountForm.working },
        { value: "30", label: accountForm.workAndStudy },
        { value: "40", label: accountForm.dontStudyOrWork }
    ]
    return <div className="form-group">
        <div className="row">
            <div className="col-12 col-xs-12">
                <h3>{accountForm.stepTwoWorkOrStudyTitle[lang]}</h3>
            </div>
            <div className="col-4 col-xs-12">
                <SelectInput
                    testName={'occupationType'}
                    testErrorName={'error-occupationType'}
                    lang={lang}
                    noOptionsMessage={accountForm.occupationType.placeholder}
                    content={accountForm.occupationType}
                    value={
                        !!state.occupationType
                            ? state.occupationType
                            : '10'
                    }
                    options={ocupationTypeOptions}
                    onChange={data =>
                        dispatch({
                            type: actions.JOB_OR_STUDY,
                            data: data,
                        })
                    }
                    className={styles.input}
                    valid={
                        !invalidFields.includes('occupationType') &&
                        validateString(state.occupationType, 30)
                    }
                    required
                />
            </div>
        </div>
        {(state.occupationType === '20' ||
            state.occupationType === '30') && (
                <div className="row">
                    <div className="col-4 col-xs-12">
                        <TextInput
                            testName="occupationInstitution"
                            testErrorName="error-occupationInstitution"
                            lang={lang}
                            content={accountForm.occupationInstitution}
                            value={state.occupationInstitution}
                            onChange={data =>
                                dispatch({
                                    type: actions.OCCUPATION_INSTITUTION,
                                    data,
                                })
                            }
                            valid={
                                state.occupationInstitution.length > 0
                                    ? !invalidFields.includes('occupationInstitution') &&
                                    smartValidateString(state.occupationInstitution)
                                    : !invalidFields.includes('occupationInstitution')
                            }
                            required
                        />
                    </div>
                    <div className="col-4 col-xs-12">
                        <TextInput
                            testName="occupationPosition"
                            testErrorName="error-occupationPosition"
                            lang={lang}
                            content={accountForm.occupationPosition}
                            value={state.occupationPosition}
                            onChange={data =>
                                dispatch({
                                    type: actions.OCCUPATION_POSITION,
                                    data,
                                })
                            }
                            valid={
                                state.occupationPosition.length > 0
                                    ? !invalidFields.includes('occupationPosition') &&
                                    smartValidateString(state.occupationPosition)
                                    : !invalidFields.includes('occupationPosition')
                            }
                            required
                        />
                    </div>
                    <div className="col-4 col-xs-12">
                        <PhoneInput
                            testName="workPhoneNumbers"
                            testErrorName="error-workPhoneNumbers"
                            label={accountForm.workPhoneNumber.label[lang]}
                            lang={lang}
                            numbers={
                                state.workPhoneNumbers.length === 0
                                    ? ['']
                                    : state.workPhoneNumbers
                            }
                            setNumbers={data =>
                                dispatch({
                                    type: actions.WORK_PHONE_NUMBERS,
                                    data,
                                })
                            }
                            invalidText={accountForm.workPhoneNumber.invalidText[lang]}
                            deleteText={accountForm.removeFieldButton[lang]}
                            addField={accountForm.addFieldButton[lang]}
                            valid={!invalidFields.includes('workPhoneNumbers')}
                            required
                        />
                    </div>
                </div>
            )}
        {(state.occupationType === '10' ||
            state.occupationType === '30') && (
                <div className="row">
                    <div className="col-4 col-xs-12">
                        <TextInput
                            testName="collegeName"
                            testErrorName="error-collegeName"
                            lang={lang}
                            content={accountForm.collegeName}
                            value={state.collegeName}
                            onChange={data =>
                                dispatch({
                                    type: actions.COLLEGE_NAME,
                                    data,
                                })
                            }
                            valid={
                                state.collegeName.length > 0
                                    ? !invalidFields.includes('collegeName') &&
                                    smartValidateString(state.collegeName)
                                    : !invalidFields.includes('collegeName')
                            }
                            required
                        />
                    </div>
                    <div className="col-4 col-xs-12">
                        <TextInput
                            testName="collegeProfession"
                            testErrorName="error-collegeProfession"
                            lang={lang}
                            content={accountForm.collegeProfession}
                            value={state.collegeProfession}
                            onChange={data =>
                                dispatch({
                                    type: actions.COLLEGE_PROFESSION,
                                    data,
                                })
                            }
                            valid={
                                state.collegeProfession.length > 0
                                    ? !invalidFields.includes('collegeProfession') &&
                                    smartValidateString(state.collegeProfession)
                                    : !invalidFields.includes('collegeProfession')
                            }
                            required
                        />
                    </div>
                    <div className="col-2 col-xs-12">
                        <DatePicker
                            testName="collegeStartedAt"
                            testErrorName="error-collegeStartedAt"
                            lang={lang}
                            accountForm={accountForm}
                            accountFormKey="collegeStartedAt"
                            onChange={data => {
                                dispatch({
                                    type: actions.COLLEGE_STARTED_AT,
                                    data,
                                })
                            }}
                            value={state.collegeStartedAt}
                            min={
                                new Date(
                                    new Date().setFullYear(new Date().getFullYear() - 10)
                                )
                            }
                            curr={
                                state.collegeEndedAt
                                    ? new Date(
                                        new Date().setDate(
                                            new Date(state.collegeEndedAt).getDate() - 1
                                        )
                                    )
                                    : new Date()
                            }
                            max={new Date()}
                            focus={focus === 'collegeStartedAt' || undefined}
                            onBlur={() => setFocus('')}
                            valid={!invalidFields.includes('collegeStartedAt')}
                            required
                        />
                    </div>
                    <div className="col-2 col-xs-12">
                        <DatePicker
                            testName="collegeEndedAt"
                            testErrorName="error-collegeEndedAt"
                            lang={lang}
                            accountForm={accountForm}
                            accountFormKey="collegeEndedAt"
                            onChange={data => {
                                dispatch({
                                    type: actions.COLLEGE_ENDED_AT,
                                    data,
                                })
                            }}
                            value={state.collegeEndedAt}
                            curr={
                                state.collegeStartedAt
                                    ? new Date(
                                        new Date().setDate(
                                            new Date(state.collegeStartedAt).getDate() + 1
                                        )
                                    )
                                    : new Date()
                            }
                            min={
                                new Date(
                                    new Date(
                                        new Date().setFullYear(new Date().getFullYear())
                                    ).setDate(new Date().getDate() + 1)
                                )
                            }
                            max={
                                new Date(
                                    new Date().setFullYear(new Date().getFullYear() + 10)
                                )
                            }
                            focus={focus === 'collegeEndedAt' || undefined}
                            onBlur={() => setFocus('')}
                            valid={!invalidFields.includes('collegeEndedAt')}
                            required
                        />
                    </div>
                </div>
            )}
    </div>
}